import axios from '@/request';
import qs from 'qs';

export default {
  async getTradeLogs(params: any) {
    return axios.get('trade-log/list', { params });
  },
  async exportTradeLogs(params: any) {
    return axios.get('trade-log/export', {
      params,
      responseType: 'blob',
    });
  },
  async newTradeLogsList(params: any) {
    return axios.get('trade-log/new-list', { params });
  },
  async newExportTradeLogsList(params: any) {
    return axios.get('trade-log/new-export', {
      params,
      responseType: 'blob',
    });
  },
  async getSettlements(params: any) {
    return axios.get('settlement-record/list', { params });
  },
  async errorCorrectionList(params: any){
  	return axios.get('settlement-correct/list', { params });
  },
  async errorCorrectionItems(params: any){
  	return axios.get('settlement-correct/items', { params });
  },
  async errorCorrectionDetail(params: any){
  	return axios.get('settlement-correct/detail', { params });
  },
	async errorCorrectionAddlog(params: any){
    return axios.post('settlement-correct/add-log', qs.stringify(params));
	},
  async getProfitSettlements(params: any) {
    return axios.get('settlement-record/profit-list', { params });
  },
  async compareProfitSettlement(params: any) {
    return axios.post('settlement-record/profit-compare', params, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  async getSettlementDetail(params: any) {
    return axios.get('settlement-record/detail', { params });
  },
  async getSettlementDetail1(params: any) {
    return axios.get('settlement-record/detail1', { params });
  },
  async getSettlementItems(params: any) {
    return axios.get('settlement-record/items', { params });
  },
  async exportSettlements(params: any) {
    return axios.get('settlement-record/export', {
      params,
      responseType: 'blob',
    });
  },
  async audit(params: any) {
    // return axios.post('settlement-record/audit', qs.stringify(params))
    return axios.post('settlement-record/audit', qs.stringify(params), {
      responseType: 'blob',
    });
  },
  async auditNormal(params: any) {
    return axios.post('settlement-record/audit', qs.stringify(params));
  },
  async statistics(params: any) {
    return axios.get('settlement-record/statistics-by-stadium', { params });
  },
  async getReconciliations(params: any) {
    return axios.get('user-settle-check-record/list', { params });
  },
  async getReconciliactionDetail(params: any) {
    return axios.get('trade-log/list', { params });
  },
  async checkAllUser(params: any) {
    return axios.post('settlement-record/check-all-user', qs.stringify(params));
  },
  async checkByUser(params: any) {
    return axios.get('settlement-record/check-by-user', { params });
  },
  async handleInvoice(params: any) {
    return axios.post('settlement-record/handle-invoice', qs.stringify(params));
  },
  async uploadInvoice(params: any) {
    return axios.post('settlement-record/upload-invoice', qs.stringify(params));
  },
  async addRemark(params: any) {
    return axios.post('settlement-record/add-remark', qs.stringify(params));
  },
  async downTradeBill(params: any) {
    return axios.get('live/down-trade-bill', { params });
  },
  async process(params: any) {
    return axios.get('settlement-record/process', { params });
  },
  async reNoticeProcess(params: any) {
    return axios.post('settlement-record/re-notice-process', qs.stringify(params));
  },
  async balance(params: any) {
    return axios.get('trade-log/balance', { params });
  },
  async alipaytransfer(params: any) {
    return axios.post('settlement-record/transfer', qs.stringify(params));
  },
  async exportBill(params: any) {
    if(params.dev){
      return axios.get("settlement-record/list-for-settle-v2", {
        params,
        responseType: "blob"
      });
    } else {
      return axios.get("settlement-record/list-for-settle-v2", {params});
    }
  }
};
